import { useSyncExternalStore } from 'react';

const subscribe = (onChange: () => void) => {
  document.addEventListener('fullscreenchange', onChange);
  return () => document.removeEventListener('fullscreenchange', onChange);
};

const getIsFullscreen = () => document.fullscreenElement != null;

/**
 * Hook that returns whether the document is in fullscreen mode
 */
export const useIsFullscreen = () =>
  useSyncExternalStore(subscribe, getIsFullscreen);

/**
 * Hook for entering and exiting fullscreen mode
 */
export default function useFullscreen(): [boolean, (enter: boolean) => void] {
  const isFullscreen = useIsFullscreen();

  const setFullscreen = (enter: boolean) => {
    if (enter) {
      document.body.requestFullscreen().catch(() => {});
    } else {
      document.exitFullscreen();
    }
  };

  return [isFullscreen, setFullscreen];
}
